import React from "react"
import { useStyles } from "app/forms/data/use-styles"
import { OldButton } from "@kit/design/old-button"
import cx from "classnames"

export const PoweredByConvertKitElement = ({ editing, onClick }) => {
  const styles = useStyles()
  const style = styles.forElement("powered_by")
  const show = style?.display === "flex"

  const handleClick = event => {
    event.preventDefault()
    onClick(event)
  }

  if (editing) {
    const className = cx("formkit-powered-by-convertkit-container", {
      "opacity-25": !show
    })
    return (
      <div className={className}>
        <OldButton
          type="button"
          className="formkit-powered-by-convertkit outline-none focus:outline-none"
          data-element="powered-by"
          data-active={show}
          data-variant="block"
          onClick={handleClick}
        >
          Powered By Kit
        </OldButton>
      </div>
    )
  }

  if (show) {
    return (
      <div className="formkit-powered-by-convertkit-container">
        <a
          href="https://kit.com"
          data-element="powered-by"
          data-variant="block"
          target="_blank"
          rel="noopener noreferrer"
        >
          Powered By Kit
        </a>
      </div>
    )
  }

  return null
}
